/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef, useState } from "react";
import * as Yup from "yup";

// api
import paymentApi from "../../api/Payment";

//css
import "./Subscription.css";

//components
import MainHeader from "../../components/headers/mainHeader/MainHeader";

//data
import { empty, errorResponse, floatval, isObject, prepareResponseData, toAmountFormat } from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import SelectField from "../../components/form/SelectField";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import { paymentSelectionMode } from "../../data/Data";
import InputFieldChange from "../../components/form/InputFieldChange";

const required = "This field is required!";
const validationSchema = Yup.object().shape({
  amount: Yup.number().required(required),
  payment_mode: Yup.string().required(required)
});
const initialValues = {
  amount: 0,
  payment_mode: 'Automatic'
};

const PayFromWallet = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  // stat status
  const [isLoading, setIsLoading] = useState(false);
  const [ availableAmount, setAvailableAmount] = useState(200_000);
  const [ selectedAmount, setSelectedAmount ] = useState(0);
  const [paymentError, setPaymentError] = useState({
    isError: false, message: '', type: ''
  });
  const [paymentHistoryStats, setPaymentHistoryStats] = useState({});
  const [ amountToPay, setAmountToPay ] = useState(0);
  const [paymentSumPerMonth, setPaymentSumPerMonth] = useState({});

  const toastTR = useRef(null);

  useEffect(() => {
    getPaymentHistoryStats();
    getPaymentSumPerMonth();
  }, []);

  useEffect(() => {
    if (selectedAmount > availableAmount) {
      setPaymentError( (prev) => ({ ...prev, 
        isError: true,
        message: 'In-sufficient fund. Fund your wallet to continue.'
      }))
    } else {
      setPaymentError( (prev) => ({ ...prev, 
        isError: false,
        message: ''
      }))
    }
  }, [selectedAmount]);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  /**
   * Get Payment History stats
   * @returns 
   */
  const getPaymentHistoryStats = async () => {
     if (isLoading) setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await paymentApi.getPaymentHistoryStats(
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Failed to fetch payment stats!"
            : "Failed to fetch payment stats"
        );
      }

      const data =
        isObject(response_data?.response)
          ? response_data.response
          : {};
      setPaymentHistoryStats(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Get Payment sum per month
   * @returns 
   */
  const getPaymentSumPerMonth = async () => {
     if (isLoading) setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await paymentApi.getPaymentSumPerMonth(
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Failed to fetch payment stats!"
            : "Failed to fetch payment stats"
        );
      }

      const data =
        isObject(response_data?.response)
          ? response_data.response
          : {};
      setPaymentSumPerMonth(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (values) => {
    try {
      if (!values) {
        return 
      }
      setAmountToPay(values?.amount || 0);
    } catch (error) {}
  }

  // handle input type
  const handleInputType = (name, setFieldValue) => async (e) => {
    const value =
      !empty(e) &&
        !empty(e.target) &&
        !empty(e.target.value)
        ? e.target.value
        : 0;
    setFieldValue(name, value);
    setSelectedAmount(value);
  }

  return (
    <>
      <AppWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Subscribe From Wallet" />
          {/* end menu header */}
            <div className="w-100pc wallet-form-description">
              <div className="wallet-fund-form">
                <div className="payment-details mb-20">
                  <div className="expected-activation">
                    <span className="title">Payment Due</span>
                    <span className="expected-amount">{user?.currency?.currency_symbol || ''}200,000.00</span> 
                    <span className="expected-amount-description">@ {user?.currency?.currency_symbol || ''}1,000.00 per Student/Term</span>
                  </div>
                  <div className="expected-activation">
                    <span className="title">Available Balance</span>
                    <span className="expected-amount">{user?.currency?.currency_symbol || ''}200,000.00</span> 
                  </div>
                </div>
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, handleChange, setFieldValue }) => (
                    <Form style={{ width: "100%" }}>
                      <div className="app_input_group">
                        <SelectField
                          labelTitle="Payment Mode"
                          placeholder="Select Payment Mode"
                          name="payment_mode"
                          required={true}
                          options={paymentSelectionMode}
                          height={50}
                          valueKey="title"
                          containerWidth={300}
                          selectedOption={values.payment_mode}
                          handleChangeFunc={handleChange}
                        />
                        {
                          values?.payment_mode?.toLowerCase() !== 'automatic' &&
                          <InputFieldChange
                            placeholder="Enter Amount is multiples of 100 (e.g 10,100 etc)"
                            name="amount"
                            height={50}
                            marginTop={10}
                            required={true}
                            type="number"
                            labelTitle="Amount"
                            onChange={handleInputType(
                              `amount`,
                              setFieldValue
                            )}
                          />
                        }
                      </div>
                      {
                        paymentError?.isError &&
                        <div className="error-text mt-5">{paymentError?.message || 'Something went wrong.'}</div>
                      }
                      <ButtonIcon
                        height={45}
                        marginTop={5}
                        color="#ffffff"
                        backgroundColor="#633ccd"
                        width={200}
                        borderColor="#633ccd"
                        buttonText="Continue"
                        type="submit"
                      />
                    </Form>
                  )}
                </Formik>
              </div>
              <div className="wallet-fund-description">
                <div className="order-summary">
                  <p className="order-summary-title">Order Summary</p>
                  <span className="order-summary-package">Premium</span>
                  <span className="order-summary-package-details">{user?.currency?.currency_symbol || ''}1,000.00 per Student/Term</span>
                  
                  <div className="amount-payable mt-20">
                    <span className="title">Amount Payable</span>
                    <span>{user?.currency?.currency_symbol || ''}{ toAmountFormat(amountToPay) }</span>
                  </div>
                  <div className="amount-payable mt-20">
                    <span className="title">Can activate</span>
                    <span>{ floatval(amountToPay/1000).toFixed(0) } students</span>
                  </div>
                </div>
                <div className="form-button-container">
                  <ButtonIcon
                    height={45}
                    marginTop={5}
                    color="#ffffff"
                    backgroundColor="#633ccd"
                    width={200}
                    borderColor="#633ccd"
                    buttonText="Subscribe"
                    type="submit"
                  />
                </div>
              </div>
            </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
      </AppWrapper>
    </>
  );
};

export default PayFromWallet;
